<h2 mat-dialog-title>{{ "login.migrate_admin.success.title" | transloco }}</h2>

<mat-dialog-content>{{"login.migrate_admin.success.info" | transloco}}</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="close()">OK</button>
</mat-dialog-actions>
